import { render, staticRenderFns } from "./VasionBrowseFolders.vue?vue&type=template&id=7c5fc555&scoped=true&"
import script from "./VasionBrowseFolders.vue?vue&type=script&lang=js&"
export * from "./VasionBrowseFolders.vue?vue&type=script&lang=js&"
import style0 from "./VasionBrowseFolders.vue?vue&type=style&index=0&id=7c5fc555&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5fc555",
  null
  
)

export default component.exports